import React from 'react'
import Logo from '../logo'

const SecondaryHeading = ({ title, subtitles, logo }) => (
  <div className='flex py-24 flex-col items-center justify-center bg-green-gefa text-white-gefa md:mb-32'>
    {
      logo ? (
        <div className='mx-4'>
          <Logo white />
        </div>
      ) : (
        <h1 className='text-white-gefa text-5xl underline text-center'>{title}</h1>
      )
    }
    {
      subtitles && subtitles.map((el, i) => (
        <div className={`${i === 0 && 'mt-16'}`} key={`subtitle_${i}`}>{el}</div>
      ))
    }
  </div>
)

export default SecondaryHeading
